<div class="layout-inner">
  <h3 class="header">{{'app.landing.advantages.title' | translate}}</h3>
  <div class="row row--first">
    <div class="cell cell--first">
      <img src="assets/img/Reach_new_customers.svg" alt="{{'app.landing.advantages.ads.title' | translate}}">
      <div class="cell__text">
        <h3 class="cell__small-header">{{'app.landing.advantages.ads.title' | translate}}</h3>
        <p>{{'app.landing.advantages.ads.text' | translate}}</p>
      </div>
    </div>
    <div class="cell">
      <img src="assets/img/Save_time.svg" alt="{{'app.landing.advantages.time.title' | translate}}">
      <div class="cell__text">
        <h3 class="cell__small-header">{{'app.landing.advantages.time.title' | translate}}</h3>
        <p>{{'app.landing.advantages.time.text' | translate}}</p>
      </div>
    </div>
  </div>
  <div class="row row--second">
    <div class="cell cell--first">
      <img src="assets/img/Simple_setup.svg" alt="{{'app.landing.advantages.help.title' | translate}}">
      <div class="cell__text">
        <h3 class="cell__small-header">{{'app.landing.advantages.help.title' | translate}}</h3>
        <p>{{'app.landing.advantages.help.text' | translate}}</p>
      </div>
    </div>
    <div class="cell">
      <img src="assets/img/No_cost.svg" alt="{{'app.landing.advantages.free.title' | translate}}">
      <div class="cell__text">
        <h3 class="cell__small-header">{{'app.landing.advantages.free.title' | translate}}</h3>
        <p>{{'app.landing.advantages.free.text' | translate}}</p>
      </div>
    </div>
  </div>
</div>
